import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Importa seus estilos globais (Design System)
import App from './App'; // Importa o componente principal

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);